import { useMediaQuery } from '@mui/material';

interface IBudgetTitleProps {
  title: string;
}

const BudgetTitle = (props: IBudgetTitleProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  
  return (
    <div className={`${isMobile ? 'text-size-18' : 'text-size-h4'} font-bold mb-4 ${isMobile ? 'px-2' : 'px-6'}`}>
      {props.title}
    </div>
  );
};

export default BudgetTitle;

